module.exports = __webpack_public_path__ + "89c456737d8ea3d01cb8f6d61caa6e6e.jpg";